import React, { Component } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import 'normalize.css';
import { TopBar, BotBar } from '../components';
import { Splash } from '../screens';
import { Theme } from '../constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Content = styled.div`
  display: flex;
  flex: 1;
`;

class App extends Component {
  state = {
    theme: 'dark',
  };

  componentDidMount() {
    const theme = localStorage.getItem('cmTheme');
    if (theme) this.setState({ theme });
  }

  selectTheme = (event) => {
    const theme = event.target.value;
    this.setState({ theme });
    localStorage.setItem('cmTheme', theme);
  };

  render() {
    const { theme } = this.state;
    const activeTheme = Theme[theme];
    return (
      <ThemeProvider theme={activeTheme}>
        <Container>
          <TopBar selectTheme={this.selectTheme} selectedTheme={theme} />
          <Content>
            <Splash />
          </Content>
          <BotBar selectTheme={this.selectTheme} selectedTheme={theme} />
        </Container>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js